(ns quuppa.qsm.not-found
  (:require [quuppa.ui.layout :as layout]))

(defn not-found-view [{:keys [text]
                       :or {text "No view defined for route"}}]
  [layout/view-content
   {:scroll-container false}
   [:h2 "Not found"]
   [:div.alert.alert-danger.align-self-start text]])
